import { useContestValidateConfig } from "@sportsmet/contest-sdk/private";
import { Skeleton } from "@sportsmet/ui";
import type { ReactNode } from "react";

import type { typeCreatePoolDraft } from "./createPoolDraft";
import { buildContestConfig } from "./survivorRulesDraft";

export type typeCreatePoolReviewRulesTextProps = {
  draft: typeCreatePoolDraft;
};

export const CreatePoolReviewRulesText = (
  props: typeCreatePoolReviewRulesTextProps,
): ReactNode => {
  const config = buildContestConfig(props.draft.rules);
  const trimmedName = props.draft.name.trim();
  const query = useContestValidateConfig(
    {
      config: config ?? {
        startDate: "2026-09-01",
        endDate: "2026-12-29",
        endDateMode: "date",
        roundGrouping: "week",
        roundLockTiming: "firstGame",
        pickBasis: "moneyline",
        advanceCriterion: "winAll",
        livesAllowed: 1,
        requiredPicksPerRound: 1,
        maxEntriesPerMember: 1,
        teamReuseAllowed: false,
        revivesAllowed: "unlimited",
        postponementPolicy: "makeUpNextRound",
        tiePolicy: "tieIsLoss",
        tiebreaker: "splitMedal",
        winPoints: 1,
        lossPoints: 0,
        skipsAllowed: false,
      },
      name: trimmedName === "" ? null : trimmedName,
    },
    { enabled: config !== null },
  );

  if (config === null) return null;

  const text = query.data?.data?.autoGeneratedText;
  const failed = Boolean(query.data?.error) || query.isError;

  return (
    <div className="flex flex-col gap-2">
      <h2 className="text-body-strong text-ink">What your players will read</h2>
      {query.isLoading ? <Skeleton shape="card" /> : null}
      {!query.isLoading && typeof text === "string" && text.length > 0 ? (
        <p
          className="whitespace-pre-wrap text-body text-ink"
          data-testid="create-pool-rules-text"
        >
          {text}
        </p>
      ) : null}
      {!query.isLoading && (failed || text === null || text === "") ? (
        <p className="text-caption text-ink-secondary">
          Couldn't load the rules text.
        </p>
      ) : null}
    </div>
  );
};
